module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Light.b0598d5c.woff";